'use client';

import { createContext, useContext, type ReactNode } from 'react';

import type { Content } from '@/lib/content';

const ContentContext = createContext<Content | null>(null);

interface ContentProviderProps {
  content: Content;
  children: ReactNode;
}

export function ContentProvider({ content, children }: ContentProviderProps) {
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export function useContent(): Content {
  const content = useContext(ContentContext);
  if (!content) {
    throw new Error('useContent must be used within ContentProvider');
  }
  return content;
}
